define('editor/edit/layers/edit/legend',['jquery', 'knockout', './legendBase', '../helpers', 'no-ui-slider', 'tinycolorpicker'], function ($, ko, legendBase, helper) {
    var viewmodel = function () {
        var self = this;

        var moduleId = self.__moduleId__;
        self.base = new legendBase(true);
        $.extend(self, self.base);
        self.__moduleId__ = moduleId;
        
        self.activate = function (editorMapId, layer, backToListFunc) {
            self.base.activate(editorMapId, layer, backToListFunc);
            self.exit = backToListFunc;
        };
    };

    return viewmodel;
});

